import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { STEP_EXECUTION_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_step_execution_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { StepExecution } from '@/types/stepExecutions.ts';

const useRetrieveStepExecution = (
  stepExecutionId?: string,
): UseQueryResult<StepExecution, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: STEP_EXECUTION_KEY(automationId, stepExecutionId),
    queryFn: async () => {
      const response = await apiClient.get(get_step_execution_url(stepExecutionId));
      return response.data;
    },
    enabled: !!stepExecutionId,
  });
};

export default useRetrieveStepExecution;
